import React from "react";
import { CONTACT_STATUSES } from "@/components/Admin/statuses";

export const StatusFilter = ({ contacts, value, onChange }) => {
  const options = [{ value: "todos", label: "Todos" }, ...CONTACT_STATUSES];
  const count = (v) => (v === "todos" ? contacts.length : contacts.filter((c) => c.status === v).length);

  return (
    <div className="admin-filter" role="tablist" aria-label="Filtrar por status" data-testid="admin-status-filter">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={`admin-filter-chip${value === o.value ? " is-active" : ""}`}
          onClick={() => onChange(o.value)}
          data-testid={`admin-filter-${o.value}`}
        >
          {o.label}
          <span className="admin-filter-count">{count(o.value)}</span>
        </button>
      ))}
    </div>
  );
};
